class Navbar {
  constructor($root) {
    if (!$root.length) return
    this.$root = $root
    $root.off().on('change', '.navbar__hidden-select', function () {
      const { origin } = new URL(location)
      const url = `${origin}${$(this).val()}`
      fetch(url, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      })
        .then(response => {
          location.reload()
        })
        .catch(error => {
          const { origin } = new URL(location)
          window.location.href = `${origin}/admin`
          console.log(error)
        })
    })
  }
}
document.addEventListener('DOMContentLoaded', () => {
  return new Navbar($('.navbar'))
})
